/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import { createApp } from 'vue';
import { initializeGtag } from "../lib/googleTagManager";
import App from '../app.vue';
import '../styles';

document.addEventListener('DOMContentLoaded', () => {
  const appElement = document.getElementById("app");
  const configElement = document.getElementById("config");
  let config = {};

  if (configElement) {
    config = configElement.dataset;
  }

  initializeGtag(config.gtmId);

  if (appElement) {
    const appProps = {
      appName: config.appName,
      baseUrl: config.url,
      csrfToken: config.csrfToken
    };

    createApp(App, appProps)
      .mount(appElement);
  }
});
